// extracted by mini-css-extract-plugin
module.exports = {"icon":"i_Y9","easy":"i_ZA","challenging":"i_ZB","hard":"i_ZC","found":"i_ZD","label":"i_ZE"};